import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  token: null,
  refreshToken: null,
  emailAdm: "",
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setToken: (state, action) => {
      state.token = action.payload;
    },
    setRefreshToken: (state, action) => {
      state.refreshToken = action.payload;
    },
    setEmailAdm: (state, action) => {
      state.emailAdm = action.payload;
    },
  },
});

export const { setToken, setRefreshToken, setEmailAdm } = authSlice.actions;

export default authSlice.reducer;
